var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#9753FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.502 12h-1v1h1v-1zM12.502 12h-4v1h4v-1zM15.502 10h-1v1h1v-1zM12.502 10h-4v1h4v-1zM15.502 8h-7v1h7V8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.502 5h-9a1.001 1.001 0 0 0-1 1v12.5a.5.5 0 0 0 .5.5h.5a.499.499 0 0 0 .4-.2l1.1-1.466 1.1 1.466a.518.518 0 0 0 .8 0l1.1-1.466 1.1 1.466a.518.518 0 0 0 .8 0l1.1-1.466 1.1 1.466a.5.5 0 0 0 .4.2h.5a.5.5 0 0 0 .5-.5V6a1.002 1.002 0 0 0-1-1zm0 12.666-1.1-1.466a.519.519 0 0 0-.8 0l-1.1 1.466-1.1-1.466a.519.519 0 0 0-.8 0l-1.1 1.466-1.1-1.466a.518.518 0 0 0-.8 0l-1.1 1.466V6h9v11.666z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesActiveIcon);
export default __webpack_public_path__ + "static/media/salesActiveIcon.f592abce32bffe92aeece12824fef626.svg";
export { ForwardRef as ReactComponent };